//
//
//
//
//
//
import PartnerManager from "page/xSchool/manager/PartnerManager.vue";
export default {
  data: function data() {
    return {};
  },
  components: {
    PartnerManager: PartnerManager
  }
};